import React from 'react';
import { useNavigate } from 'react-router-dom'; // Using useNavigate for navigation
import Navbar from '../components/Navbar'; // Adjust the path as needed
import '../styles/CAD.css';

const CloudImplementationService = () => {
    const navigate = useNavigate();

    // For demonstration, the Learn More buttons currently redirect to Google.
    // Replace with your actual navigation logic or paths as needed.
    const handleNavigation = (path) => {
        navigate('/contact');
        // Alternatively, if using React Router:
        // navigate(path);
    };

    return (
        <>
            <Navbar />
            <div className="custom-app-development">
                <div className="content-box">
                    <header className="header">
                        <h1>Cloud Implementation Service</h1>
                        <p className="tagline">
                            Experience a seamless cloud transition with our tailored implementation services.
                        </p>
                    </header>
                    
                    <section className="introduction">
                        <p>
                            Our Cloud Implementation Service provides end-to-end solutions for migrating your business to the cloud. We work with you every step of the way—from initial assessment and planning to deployment and post-migration support—to ensure a smooth, efficient, and secure transition.
                        </p>
                    </section>
                    
                    <section className="why-choose-us">
                        <h2>Why Choose Our Cloud Implementation?</h2>
                        <p>
                            With years of expertise in cloud migration, our certified professionals deliver a personalized approach that minimizes downtime and optimizes performance. We ensure that your transition is secure, scalable, and cost-effective.
                        </p>
                    </section>
                    
                    <section className="tech-stack">
                        <h2>Our Implementation Process</h2>
                        <p>
                            We follow a structured process that includes:
                        </p>
                        <ul>
                            <li><strong>Cloud Readiness Assessment:</strong> Evaluate your current IT landscape to determine cloud suitability.</li>
                            <li><strong>Strategic Planning:</strong> Develop a customized migration roadmap tailored to your business needs.</li>
                            <li><strong>Seamless Migration:</strong> Execute a secure transition of applications and data with minimal disruption.</li>
                            <li><strong>Post-Migration Optimization:</strong> Fine-tune performance, security, and cost-efficiency in your new cloud environment.</li>
                        </ul>
                    </section>
                    
                    <section className="secure-practices">
                        <h2>Secure & Optimized Deployment</h2>
                        <p>
                            We leverage industry best practices and cutting-edge tools to ensure that your cloud infrastructure is secure, optimized, and compliant. Our proactive support ensures lasting value and performance.
                        </p>
                    </section>
                    
                    <section className="services">
                        <h2>Our Cloud Implementation Services</h2>
                        <div className="service-container">
                            <div className="service-box">
                                <h3>Cloud Readiness Assessment</h3>
                                <p>
                                    Analyze your existing IT setup to chart the best path for a cloud transition.
                                </p>
                                <button className="learn-more" onClick={() => handleNavigation('/readiness-assessment')}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Cloud Migration & Integration</h3>
                                <p>
                                    Seamlessly migrate and integrate your data and applications into a secure cloud environment.
                                </p>
                                <button className="learn-more" onClick={() => handleNavigation('/cloud-migration')}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Post-Migration Optimization</h3>
                                <p>
                                    Enhance performance, reduce costs, and ensure the security of your new cloud setup.
                                </p>
                                <button className="learn-more" onClick={() => handleNavigation('/post-migration')}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Cloud Support & Maintenance</h3>
                                <p>
                                    Receive ongoing support and proactive maintenance to keep your cloud environment running at its best.
                                </p>
                                <button className="learn-more" onClick={() => handleNavigation('/cloud-support')}>
                                    Learn More
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default CloudImplementationService;
